module.exports = __webpack_public_path__ + "static/media/ts4tj73.7b184791.png";